import type { Holiday } from '../types';

export const DEFAULT_PSTN_OUTBOUND_DIAL_TIMEOUT_SECONDS = 25;

export interface SystemSettingsUpdatePayloadInput {
  pstnOutboundDialTimeoutSeconds: unknown;
  holidays: Holiday[];
  retryStatuses: string[];
}

/**
 * Normalizes the outbound PSTN dial timeout from unknown input into a valid integer.
 * Invalid values fallback to the project default.
 */
export function normalizePstnOutboundDialTimeoutSeconds(value: unknown): number {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return DEFAULT_PSTN_OUTBOUND_DIAL_TIMEOUT_SECONDS;
  }
  return Math.floor(parsed);
}

/**
 * Builds the canonical payload accepted by `/api/system-settings/`.
 * Operating hours are intentionally excluded because they are tenant-scoped.
 */
export function buildSystemSettingsUpdatePayload(
  input: SystemSettingsUpdatePayloadInput
): {
  pstnOutboundDialTimeoutSeconds: number;
  holidays: Holiday[];
  retryStatuses: string[];
} {
  return {
    pstnOutboundDialTimeoutSeconds: normalizePstnOutboundDialTimeoutSeconds(
      input.pstnOutboundDialTimeoutSeconds
    ),
    holidays: input.holidays,
    retryStatuses: input.retryStatuses,
  };
}
